const env = (key) => window.__ENV__?.[key] || import.meta.env[key];

export const REACT_APP_API_KEY = env("REACT_APP_API_KEY");
export const REACT_APP_BASE_URL = env("REACT_APP_BASE_URL");
